<template>
  <div>
    <form autocomplete="off" @submit.prevent="onSubmit($event)">
      <div class="title-off-block">
        <div class="title">
          {{ $t('account.titles.title') }}
        </div>
        <div class="block-switch">
          <c-switch
            name="enabled"
            v-model="model.enabled"
            :description="$t('account.labels.enabled_disabled')"
          ></c-switch>
        </div>
      </div>
      <div class="info-block">
        <!-- Nesutinku -->
        <div class="form-group row">
          <label for="surname_enabled" class="col-md-3">
            Kontaktinės informacijos rodymas
          </label>
          <div class="col-md-9">
            <c-switch
              name="surname_enabled"
              v-model="model.surname_enabled"
              :description="$t('account.labels.show_surname')"
            ></c-switch>
          </div>
        </div>
        <!-- Nesutinku -->
        <div class="form-group row">
          <label for="email_enabled" class="col-md-3"></label>
          <div class="col-md-9">
            <c-switch
              name="email_enabled"
              v-model="model.email_enabled"
              :description="$t('account.labels.show_email')"
            ></c-switch>
          </div>
        </div>
        <!-- Nesutinku -->
        <div class="form-group row">
          <label for="phone_enabled" class="col-md-3"></label>
          <div class="col-md-9">
            <c-switch
              name="phone_enabled"
              v-model="model.phone_enabled"
              :description="$t('account.labels.show_phone')"
            ></c-switch>
          </div>
        </div>

        <!-- Ad Duration -->
        <div class="form-group row">
          <label for="duration_standard" class="col-md-3">
            Anketos publikavimas
          </label>
          <div class="col-md-9">
            <c-switch
              name="duration_standard"
              v-model="model.duration_standard"
              description="Naudoti standartinį anketos publikavimo (30 d.) periodą"
            ></c-switch>
          </div>
        </div>
        <!-- Start day -->
        <div
          class="form-group row"
          :class="state('start_at')"
          v-if="!model.duration_standard"
        >
          <label class="col-md-3">Publikavimo pradžia</label>
          <div class="col-md-9">
            <datepicker
              input-class="form-control start_date-field"
              calendar-button-icon="far fa-calendar-alt"
              :minimum-view="'day'"
              :maximum-view="'year'"
              :initial-view="'year'"
              :format="'yyyy-MM-dd'"
              v-model="model.start_at"
              :disabled-dates="disabledDates"
              :language="lt"
            ></datepicker>
          </div>
        </div>
        <div
          class="form-validation row"
          :class="state('start_at')"
          v-if="state('start_at')"
        >
          <div class="col-md-3"></div>
          <div class="col-md-9">
            <b-form-feedback>
              {{ feedback('start_at') }}
            </b-form-feedback>
          </div>
        </div>
        <!-- End day -->
        <div
          class="form-group row"
          :class="state('end_at')"
          v-if="!model.duration_standard"
        >
          <label class="col-md-3">Publikavimo pabaiga</label>
          <div class="col-md-9">
            <datepicker
              input-class="form-control start_date-field"
              calendar-button-icon="far fa-calendar-alt"
              :minimum-view="'day'"
              :maximum-view="'year'"
              :initial-view="'year'"
              :format="'yyyy-MM-dd'"
              v-model="model.end_at"
              :disabled-dates="disabledDates"
              :language="lt"
            ></datepicker>
          </div>
        </div>
        <div
          class="form-validation row"
          :class="state('end_at')"
          v-if="state('end_at')"
        >
          <div class="col-md-3"></div>
          <div class="col-md-9">
            <b-form-feedback>
              {{ feedback('end_at') }}
            </b-form-feedback>
          </div>
        </div>
      </div>
      <div class="title-off-block title-off-block tob-padding">
        <div class="title">
          Darbo pozicijos
        </div>
      </div>
      <div class="info-block">
        <!-- Categories -->
        <div class="form-group row align-items-start">
          <label class="col-md-3">Pozicijos</label>
          <div class="col-md-9">
            <multiselect
              v-model="model.categories_job"
              :options="categories"
              :multiple="true"
              :searchable="true"
              track-by="id"
              label="name"
              placeholder="Pasirinkite"
            ></multiselect>

            <!--            <b-form-checkbox-group
              stacked
              v-model="model.categories_job"
              name="categories_job[]"
            >
              <b-form-checkbox
                v-for="category in categories"
                :key="category.id"
                :value="category.id"
              >
                {{ category.name }}
              </b-form-checkbox>
            </b-form-checkbox-group>-->
          </div>
        </div>
      </div>

      <div class="title-off-block title-off-block tob-padding">
        <div class="title">
          Kompetencijos
        </div>
      </div>
      <div class="info-block">
        <!-- Work experience norway -->
        <div class="form-group row">
          <label for="work_experience_no" class="col-md-3">
            Darbo Norvegijoje patirtis
          </label>
          <div class="col-md-9">
            <c-switch
              name="work_experience_no"
              v-model="model.work_experience_no"
              description=""
            ></c-switch>
          </div>
        </div>
        <!-- ID number -->
        <div class="form-group row">
          <label for="id_number" class="col-md-3">D numeris arba ID </label>
          <div class="col-md-9">
            <c-switch
              name="id_number"
              v-model="model.id_number"
              description=""
            ></c-switch>
          </div>
        </div>
        <!-- Driving permit -->
        <div class="form-group row">
          <label for="driving_permit" class="col-md-3">
            Vairuotojo pažymėjimas
          </label>
          <div class="col-md-9">
            <c-switch
              name="driving_permit"
              v-model="model.driving_permit"
              description=""
            ></c-switch>
          </div>
        </div>
        <!-- Job ad description -->
        <div
          class="form-group row align-items-start"
          :class="state('description')"
        >
          <label class="col-md-3">Kiti privalumai:</label>
          <div class="col-md-9">
            <p-richtexteditor
              name="description"
              class="form-control"
              v-model="model.description"
            ></p-richtexteditor>
          </div>
        </div>
        <div
          class="form-validation row"
          :class="state('description')"
          v-if="state('description')"
        >
          <div class="col-md-3"></div>
          <div class="col-md-9">
            <b-form-feedback>
              {{ feedback('description') }}
            </b-form-feedback>
          </div>
        </div>
      </div>

      <div class="title-off-block title-off-block tob-padding">
        <div class="title">
          Kalbų mokėjimas
        </div>
      </div>
      <div class="info-block">
        <!-- Languages -->
        <div class="form-group row align-items-start">
          <label class="col-md-3">Kalba</label>

          <div class="col-md-9">
            <b-form-checkbox-group
              stacked
              v-model="model.languages_job"
              name="languages_job[]"
            >
              <b-form-checkbox
                v-for="language in languages"
                :key="language.id"
                :value="language.id"
              >
                {{ language.de }}
              </b-form-checkbox>
            </b-form-checkbox-group>
          </div>
        </div>
      </div>

      <div class="title-off-block title-off-block tob-padding">
        <div class="title">
          Darbo patirtis
        </div>
      </div>
      <div class="info-block">
        <!-- Work experience -->
        <div
          class="form-group row align-items-start"
          :class="state('work_experience')"
        >
          <label class="col-md-3">Darbo patirtis</label>
          <div class="col-md-9">
            <p-richtexteditor
              name="can_desc"
              class="form-control"
              v-model="model.work_experience"
            ></p-richtexteditor>
          </div>
        </div>
        <div
          class="form-validation row"
          :class="state('work_experience')"
          v-if="state('work_experience')"
        >
          <div class="col-md-3"></div>
          <div class="col-md-9">
            <b-form-feedback>
              {{ feedback('work_experience') }}
            </b-form-feedback>
          </div>
        </div>
      </div>

      <div class="title-off-block title-off-block tob-padding">
        <div class="title">
          Pageidautina darbo geografinė vieta
        </div>
      </div>
      <div class="info-block">
        <!-- Country -->
        <div class="form-group row" :class="state('country_code')">
          <label for="country_code" class="col-md-3">
            {{ $t('account.labels.country') }}
          </label>
          <div class="col-md-9">
            <multiselect
              class="input-m-select input-h-select"
              v-model="model.country"
              track-by="code"
              label="asciiname"
              placeholder=""
              :options="countries"
              :searchable="false"
              :allow-empty="false"
              :multiple="false"
              autocomplete="off"
              @input="setCountry"
              @select="setCountry"
              @remove="removeCountry"
            >
              <template slot="singleLabel" slot-scope="{ option }">
                <strong>{{ option.asciiname }} ({{ option.name }})</strong>
                <img
                  class="option__img option__img-selected-right country-flag"
                  :src="getFlag(option.icode)"
                  :alt="option.name"
                />
              </template>
              <template slot="option" slot-scope="props">
                <div class="option__desc">
                  <span class="option__title">{{
                    props.option.asciiname
                  }}</span>
                  <span class="option__small">({{ props.option.name }})</span>
                </div>
                <img
                  class="option__img option__img-right country-flag"
                  :src="getFlag(props.option.icode)"
                  :alt="props.option.name"
                />
              </template>
              <template slot="caret" slot-scope="{ toggle }">
                <div @mousedown.prevent.stop="toggle" class="toggle-hold">
                  <font-awesome-icon
                    :icon="['fa', 'chevron-down']"
                  ></font-awesome-icon>
                </div>
              </template>
            </multiselect>
          </div>
        </div>
        <div
          class="form-validation row"
          :class="state('country_code')"
          v-if="state('country_code')"
        >
          <div class="col-md-3"></div>
          <div class="col-md-9">
            <b-form-feedback>
              {{ feedback('country_code') }}
            </b-form-feedback>
          </div>
        </div>
        <div class="form-group row">
          <label for="place" class="col-md-3">
            {{ $t('account.labels.location_search') }}
          </label>
          <div class="col-md-9">
            <div class="g-search-wrap">
              <gmap-place-input
                @place_changed="setPlace"
                :class-name="`form-control mw-100 form-control-search`"
                :component-restrictions="{
                  country: model.country_code
                    ? model.country_code.toLowerCase().trim()
                    : 'no'
                }"
              >
              </gmap-place-input>
              <i class="fas fa-search"></i>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label for="place" class="col-md-3"> </label>
          <div class="col-md-9">
            <div class="search-divider"></div>
          </div>
        </div>
        <!-- City -->
        <div class="form-group row" :class="state('adr_city')">
          <label for="name" class="col-md-3">
            {{ $t('account.labels.city') }}
          </label>
          <div class="col-md-9">
            <input
              type="text"
              class="form-control name-field form-field-disabled"
              name="adr_city"
              id="adr_city"
              v-model="model.adr_city"
              readonly
            />
          </div>
        </div>
        <div
          class="form-validation row"
          :class="state('adr_city')"
          v-if="state('adr_city')"
        >
          <div class="col-md-3"></div>
          <div class="col-md-9">
            <b-form-feedback>
              {{ feedback('adr_city') }}
            </b-form-feedback>
          </div>
        </div>
        <!-- All norway -->
        <div class="form-group row">
          <label for="all_no" class="col-md-3"></label>
          <div class="col-md-9">
            <c-switch
              name="all_no"
              v-model="model.all_no"
              description="Darbo vieta gali būti ir bet kurioje Norvegijos vietoje"
            ></c-switch>
          </div>
        </div>
        <!-- Radius -->
        <div
          class="form-group row"
          :class="state('ad_radius')"
          v-if="!model.all_no"
        >
          <label for="ad_radius" class="col-md-3">
            {{ $t('account.labels.radius') }}
          </label>
          <div class="col-md-9">
            <input
              type="number"
              id="ad_radius"
              name="ad_radius"
              class="form-control form-control-salary salary-min"
              v-model="model.ad_radius"
              min="0"
              max="999"
            />
            <div class="col-inf-currency salary-currency salary-currency-max">
              {{ $t('account.labels.km') }}
            </div>
          </div>
        </div>
        <div
          class="form-validation row"
          :class="state('ad_radius')"
          v-if="state('ad_radius')"
        >
          <div class="col-md-3"></div>
          <div class="col-md-9">
            <b-form-feedback>
              {{ feedback('ad_radius') }}
            </b-form-feedback>
          </div>
        </div>
        <div class="form-group row row-full-width">
          <label for="place" class="col-md-12">
            {{ $t('account.labels.specify') }}
          </label>
        </div>
        <div class="form-group row">
          <div class="col-12">
            <GmapMap
              :center="{
                lat: lat(),
                lng: lng()
              }"
              :zoom="13"
              map-type-id="roadmap"
              style="width: 100%; height: 400px"
            >
              <GmapMarker
                :position="{
                  lat: lat(),
                  lng: lng()
                }"
                :clickable="true"
                :draggable="true"
                @dragend="updateCoordinates($event.latLng)"
              ></GmapMarker>
            </GmapMap>
          </div>
        </div>
      </div>
      <div class="info-block info-block-action">
        <!-- Submit -->
        <div class="form-group row">
          <div class="col-12">
            <button type="submit" class="btn blue" style="width: 153px;">
              {{ $t('account.buttons.save') }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import form from '@core/js/mixins/form'
import Multiselect from 'vue-multiselect'
import Datepicker from 'vuejs-datepicker'
import { en, lt, no } from 'vuejs-datepicker/dist/locale'

const getPlaceData = (place, infoType, format) => {
  let data,
    addressComponents = [...place.address_components]

  addressComponents.forEach(componentItem => {
    if (componentItem.types[0] === infoType) {
      data = componentItem[format]
      addressComponents.length = 0
    }
  })

  return data
}

export default {
  title: '',
  name: 'ProfileData',
  components: { Multiselect, Datepicker },
  mixins: [form],
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    },
    categories: {
      type: Array,
      default: () => []
    },
    categoriesJob: {
      type: Array,
      default: () => []
    },
    countries: {
      type: Array,
      default: () => []
    },
    languages: {
      type: Array,
      default: () => []
    },
    languagesJob: {
      type: Array,
      default: () => []
    },
    /*    genders: {
      type: Array,
      default: () => []
    },
    gender: {
      type: Object,
      default: () => []
    },*/
    country: {
      type: [Array, Object],
      default: () => []
    }
  },
  data() {
    return {
      modelName: 'profile',
      resourceRoute: 'profile',
      listPath: '/account/profile',
      routePath: '/account/profile',
      createPath: '/account/profile',
      updatePath: '/account/profile/update',
      disabledDates: {
        to: new Date(Date.now() - 86400000)
      },
      isModal: this.modal,
      isBusy: false,
      mFiles: [],
      myFiless: [],
      galleryFiles: [],
      gallery: [],
      dragging: false,
      icons: {
        opened: '<i class="fas fa-chevron-up"></i>',
        closed: '<i class="fas fa-chevron-down"></i>'
      },
      eId: 1,
      msg: '',
      selectedSeasons: [],
      nonDeletable:
        "You can't remove the first item, so if you're not going to use it just leave it blank",
      cityFieldDisabled: true,
      noData: false,
      // Cities
      items: [],
      isLoading: false,
      timeoutId: null,
      place: '',
      latLng: {},
      locations: [],
      formatedAddresses: [],
      autocomplete: null,
      autocompleteText: '',
      alwaysOpen: false,
      openOnFocus: false,
      en: en,
      lt: lt,
      no: no
    }
  },
  computed: {
    model() {
      return this.$store.getters['profile/data']
    }
  },
  watch: {
    autocompleteText: function(newVal, oldVal) {
      this.$emit('inputChange', { newVal, oldVal }, this.id)
    }
  },
  beforeMount() {
    if (this.isNew) {
      this.$store.commit('profile/emptyFields')
    } else {
      this.$store.commit('profile/setData', this.data)
      //this.$store.commit('profile/setGender', this.gender)

      if (this.countries.length == 1) {
        this.$store.commit('profile/setCountry', this.countries[0])
      } else {
        this.$store.commit('profile/setCountry', this.country)
      }
      this.$store.commit('profile/setLanguagesJob', this.languagesJob)
      this.$store.commit(
        'profile/setCategoriesJob',
        JSON.parse(JSON.stringify(this.categoriesJob).replace(/"/g, ''))
      )
    }
  },
  created() {},
  mounted() {},
  methods: {
    setPlaceText(place) {
      this.place = place
    },
    setPlace(place) {
      if (place && place.geometry && place.geometry.location) {
        this.latLng = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        }
        this.model.coordinates = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        }
        this.$nextTick(() => {
          this.decodeLatLong()
        })
      }
    },
    lat() {
      return parseFloat(
        isNaN(this.model.coordinates.lat)
          ? this.model.coordinates.latitude
          : this.model.coordinates.lat
      )
    },
    lng() {
      return parseFloat(
        isNaN(this.model.coordinates.lng)
          ? this.model.coordinates.longitude
          : this.model.coordinates.lng
      )
    },
    latCity() {
      return parseFloat(
        isNaN(this.model.coordinates.lat)
          ? this.model.coordinates.lat
          : this.model.city_latitude
      )
    },
    lngCity() {
      return parseFloat(
        isNaN(this.model.coordinates.lng)
          ? this.model.coordinates.lng
          : this.model.city_longitude
      )
    },
    updateCoordinates(location) {
      this.model.coordinates = {
        lat: location.lat(),
        lng: location.lng()
      }
      this.$nextTick(() => {
        this.decodeLatLong()
      })
    },
    decodeLatLong(position) {
      this.$gmapApiPromiseLazy().then(() => {
        // eslint-disable-next-line no-undef
        const geocoder = new google.maps.Geocoder()

        geocoder.geocode(
          {
            location: {
              lat: this.model.coordinates.lat,
              lng: this.model.coordinates.lng
            }
          },
          (results, status) => {
            if (status === 'OK') {
              this.model.adr_country = getPlaceData(
                results[0],
                'country',
                'long_name'
              )
              this.model.adr_state = getPlaceData(
                results[0],
                'administrative_area_level_1',
                'short_name'
              )
              this.model.adr_district =
                getPlaceData(results[0], 'sublocality', 'long_name') ||
                getPlaceData(results[0], 'sublocality_level_1', 'long_name')
              this.model.adr_city =
                getPlaceData(results[0], 'locality', 'long_name') ||
                getPlaceData(
                  results[0],
                  'administrative_area_level_2',
                  'long_name'
                )
              this.model.adr_street = getPlaceData(
                results[0],
                'route',
                'long_name'
              )
              this.model.adr_street_number = getPlaceData(
                results[0],
                'street_number',
                'long_name'
              )
            }
          }
        )
      })
    },
    // gets a flag picture
    getFlag(flagName) {
      try {
        return require(`@main/images/flags/${flagName.toLowerCase()}.svg`)
      } catch (e) {
        return require('@main/images/flags/undefined.svg')
      }
    },
    removeImg(id) {
      this.$store.dispatch('profile/removeImgLine', id)
    },
    changePic(error, e) {
      this.model.photo = this.mFiles
    },
    updateFiles(error, file) {
      if (error) return false
      this.myFiless.push(file.serverId)
      //this.$emit("getFiles", this.myFiless)
      this.model.photo = '/storage/' + this.myFiless
      this.model.file_id = file.serverId
    },
    updateGalleryFiles(error, file) {
      if (error) return false
      if (file.serverId) {
        this.galleryFiles.push(file.serverId)
        //this.$emit("getFiles", this.myFiless)

        if (this.model.gallery) {
          let gallery = this.model.gallery
          gallery.push({
            id: '',
            order: '',
            title: '',
            description: '',
            file_origin: file.serverId,
            enabled: true
          })
          this.model.gallery = gallery
        } else {
          this.model.gallery = [
            {
              id: '',
              order: '',
              title: '',
              description: '',
              file_origin: file.serverId,
              enabled: true
            }
          ]
        }

        this.galleryFiles = []
      }
    },
    setGender(selectedOption) {
      if (selectedOption) {
        this.model.gender_id = selectedOption.id
      }
    },
    removeGender() {
      this.model.gender_id = ''
    },
    removeCategory(id) {
      this.$store.dispatch('profile/removeCategoryLine', id)
    },
    addCategory: function() {
      this.eIdCat++
      this.$store.dispatch('profile/addEmptyCategory', this.eIdCat)
    },
    addCountry: function() {
      this.eIdLoc++
      this.$store.dispatch('profile/addEmptyCountry', this.eIdLoc)
    },
    setCountry(selectedOption) {
      if (selectedOption) {
        this.model.country_code = selectedOption.code
        this.model.loc = selectedOption.code
        this.model.city_id = ''
        this.model.city = ''
        this.cityFieldDisabled = false
      }
    },
    removeCountry() {
      this.model.country_code = ''
      this.model.loc = ''
      this.model.city_id = ''
      this.model.city = ''
      this.cityFieldDisabled = true
    },
    setCity(selectedOption) {
      if (selectedOption) {
        this.model.city_id = selectedOption.id
        this.model.city_latitude = selectedOption.latitude
        this.model.city_longitude = selectedOption.longitude
        this.model.coordinates.lng = selectedOption.latitude
        this.model.coordinates.lat = selectedOption.longitude
      }
    },
    removeCity(selectedOption) {
      if (selectedOption) {
        this.model.city_id = ''
        this.model.city = ''
      }
    },
    getCity() {
      if (this.model.city) {
        return this.model.city.name
      }
      return ''
    },
    async onSearch(search) {
      const lettersLimit = 1

      this.noData = false
      if (search.length < lettersLimit) {
        this.items = []
        this.isLoading = false
        return
      }
      this.isLoading = true

      clearTimeout(this.timeoutId)
      this.timeoutId = setTimeout(async () => {
        const response = await fetch(
          `/api/cities/suggest?country=${this.model.country_code}&query=${search}`
        )

        let responseData = await response.json()

        this.items = responseData.items
        this.isLoading = false

        if (!this.items.length) this.noData = true
      }, 100)
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.country-flag {
  max-width: 30px;
  margin-right: 10px;
  border: 1px solid #eaecf0;
}
</style>
<style scoped>
.country-flag {
  max-width: 30px;
  margin-right: 10px;
  border: 1px solid #eaecf0;
}

.button {
  margin-top: 35px;
}

.text {
  margin: 20px;
}
</style>
